module.exports = __webpack_public_path__ + "static/media/dna.f40e13ed.svg";